import { useMutation } from "@tanstack/react-query";
import { SubscriptionRequestService } from "../services/subscriptionRequest.service";
import type { SubscriptionRequestPayload } from "../types/subscriptionRequest.types";

type Params = { organizationId: string };

export const useCreateSubscriptionRequestMutation = ({ organizationId }: Params) =>
  useMutation({
    mutationFn: (payload: SubscriptionRequestPayload) =>
      SubscriptionRequestService.create(organizationId, payload),
  });
